module.exports = __webpack_public_path__ + "img/ru.c6e99030.png";